import React from 'react';
import { Briefcase, Calendar, Trophy, GraduationCap } from 'lucide-react';

const experienceList = [
  {
    year: "2004 - Presente",
    role: "Fundador y Director General",
    company: "JBR INMOBILIARIA",
    description: "Fundación y dirección de una de las inmobiliarias más reconocidas de Castilla y León. Liderando un equipo de profesionales comprometidos con la excelencia y la satisfacción del cliente.",
    icon: "trophy"
  },
  {
    year: "2010 - Presente",
    role: "Formación Internacional CRS",
    company: "Certified Residential Specialist",
    description: "Formación continua en los eventos CRS Sellabration en Las Vegas, Orlando, Los Ángeles, Phoenix y Miami. Múltiples certificaciones en técnicas de venta, negociación, IA inmobiliaria y planificación de negocio.",
    icon: "graduation"
  },
  {
    year: "1998 - 2004",
    role: "Licenciatura ADE",
    company: "Universidad de Valladolid",
    description: "Licenciado en Administración y Dirección de Empresas por la Facultad de Ciencias Económicas y Empresariales de Valladolid.",
    icon: "briefcase"
  }
];

const achievementsList = [
  { number: "5.000+", label: "Transacciones Realizadas", description: "Compraventas y alquileres gestionados con éxito desde 2004" },
  { number: "21", label: "Años de Experiencia", description: "Trayectoria consolidada liderando el sector inmobiliario" },
  { number: "4x", label: "Mejor Inmobiliaria CyL", description: "Premio Google: 2022, 2023, 2024 y 2025" },
  { number: "CRS", label: "Certificación Internacional", description: "Certified Residential Specialist - USA" }
];

const Experience = () => {
  const getIcon = (iconType) => {
    switch(iconType) {
      case 'trophy': return <Trophy className="w-5 h-5 text-white/80" />;
      case 'graduation': return <GraduationCap className="w-5 h-5 text-white/80" />;
      default: return <Briefcase className="w-5 h-5 text-white/80" />;
    }
  };

  return (
    <section id="trayectoria" className="bg-[#1a365d] py-20 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="max-w-3xl mb-16">
          <span className="text-sm text-white/60 tracking-wider uppercase">Trayectoria</span>
          <h2 className="text-3xl lg:text-4xl font-light text-white mt-4 leading-tight">
            Más de dos décadas de experiencia
          </h2>
          <p className="text-base text-white/70 mt-4">
            Desde 2004 liderando el sector inmobiliario en Castilla y León con formación internacional y reconocimiento constante.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-16">
          <div className="space-y-8">
            {experienceList.map((exp, idx) => (
              <div key={idx} className="flex gap-6">
                <div className="flex flex-col items-center">
                  <div className="w-10 h-10 flex items-center justify-center bg-white/10 rounded-full">
                    {getIcon(exp.icon)}
                  </div>
                  {idx < experienceList.length - 1 && (
                    <div className="w-px h-full bg-white/20 mt-4"></div>
                  )}
                </div>
                <div className="pb-8">
                  <div className="flex items-center gap-2 mb-2">
                    <Calendar className="w-4 h-4 text-white/60" />
                    <span className="text-sm text-white/60">{exp.year}</span>
                  </div>
                  <h3 className="text-lg font-medium text-white mb-1">{exp.role}</h3>
                  <p className="text-sm text-white/80 mb-2">{exp.company}</p>
                  <p className="text-sm text-white/60 leading-relaxed">{exp.description}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="grid grid-cols-2 gap-6">
            {achievementsList.map((achievement, idx) => (
              <div
                key={idx}
                className="bg-white/5 p-6 lg:p-8 hover:bg-white/10 transition-colors duration-300"
              >
                <p className="text-3xl lg:text-4xl font-light text-white mb-2">
                  {achievement.number}
                </p>
                <p className="text-sm font-medium text-white mb-1">{achievement.label}</p>
                <p className="text-xs text-white/60 leading-relaxed">{achievement.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Experience;
